var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _g, _rect23, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg25UpdatedNewTableActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 68,
    viewBox: "0 0 131 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.74219,
    y: 35.7417,
    width: 114.839,
    height: 24.5161,
    rx: 2.58065,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5488,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.1621,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36.7754,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 71.6133,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 83.2266,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 94.8398,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 106.451,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 48.3867,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5488,
    y: 62.8384,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "black"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 25.1621,
    y: 62.8384,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "black"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 36.7754,
    y: 62.8384,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "black"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 62.8384,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "black"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 71.6133,
    y: 62.8384,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "black"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 83.2266,
    y: 62.8384,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "black"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 94.8398,
    y: 62.8384,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "black"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 106.451,
    y: 62.8384,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "black"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 48.3867,
    y: 62.8384,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "black"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    y: 42.8389,
    width: 5.16129,
    height: 10.3226,
    rx: 2.58065,
    fill: "black"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 125.16,
    y: 42.8389,
    width: 5.16129,
    height: 10.3226,
    rx: 2.58065,
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_193_7723",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 40,
    width: 16,
    height: 16
  }, _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 48.3867,
    y: 40.2583,
    width: 15.4839,
    height: 15.4839,
    fill: "url(#pattern0_193_7723)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_193_7723)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.3867,
    y: 40.2583,
    width: 15.4839,
    height: 15.4839,
    fill: "white"
  }))), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 63.8711,
    y: 38.3228,
    width: 18.0645,
    height: 19.3548,
    rx: 2.58065,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.4875 51.5V50.7568V50.3748C66.4875 49.9963 66.5581 49.6695 66.6991 49.3942C66.8402 49.1155 67.026 48.8746 67.2566 48.6716C67.4905 48.4652 67.7452 48.2845 68.0204 48.1297C68.2991 47.9748 68.5778 47.8286 68.8566 47.691C69.1353 47.5533 69.3899 47.4157 69.6204 47.2781C69.8544 47.137 70.0419 46.9804 70.183 46.8084C70.3241 46.6363 70.3946 46.4333 70.3946 46.1994C70.3946 45.9 70.2897 45.6557 70.0798 45.4665C69.8733 45.2772 69.5895 45.1826 69.2282 45.1826C68.8531 45.1826 68.5348 45.291 68.2733 45.5077C68.0118 45.7245 67.8501 46.0514 67.7882 46.4884H66.3482C66.355 46.0135 66.4652 45.5834 66.6785 45.1981C66.8953 44.8092 67.2187 44.5013 67.6488 44.2742C68.0789 44.0471 68.6191 43.9335 69.2695 43.9335C69.8269 43.9335 70.3069 44.0282 70.7095 44.2174C71.1155 44.4067 71.4286 44.6699 71.6488 45.0071C71.869 45.3443 71.9791 45.7383 71.9791 46.189C71.9791 46.5641 71.9103 46.8875 71.7727 47.1594C71.635 47.4312 71.4527 47.6634 71.2256 47.8561C70.9985 48.0488 70.749 48.2174 70.4772 48.3619C70.2054 48.5065 69.9335 48.6406 69.6617 48.7645C69.3933 48.8884 69.1456 49.0157 68.9185 49.1465C68.6914 49.2738 68.509 49.4183 68.3714 49.58C68.2338 49.7417 68.1649 49.9361 68.1649 50.1632V50.2303H71.9688V51.5H66.4875ZM76.0593 51.6135C75.5707 51.6135 75.1165 51.5378 74.6967 51.3865C74.2769 51.2351 73.9139 51.0286 73.6077 50.7671C73.3014 50.5022 73.0692 50.1994 72.9109 49.8587L74.0877 49.1619C74.2219 49.3959 74.3733 49.6075 74.5419 49.7968C74.7105 49.9826 74.9049 50.1305 75.1251 50.2406C75.3488 50.3473 75.6085 50.4006 75.9045 50.4006C76.3518 50.4006 76.7113 50.2819 76.9832 50.0445C77.255 49.8071 77.3909 49.4974 77.3909 49.1155C77.3909 48.8746 77.329 48.6596 77.2051 48.4703C77.0847 48.2776 76.9178 48.1262 76.7045 48.0161C76.4911 47.906 76.2417 47.851 75.9561 47.851C75.8047 47.851 75.6602 47.8647 75.5225 47.8923C75.3883 47.9163 75.2507 47.9645 75.1096 48.0368C74.972 48.1056 74.8189 48.2054 74.6503 48.3361C74.6021 48.3568 74.5677 48.3671 74.547 48.3671C74.5298 48.3671 74.4954 48.3551 74.4438 48.331L73.3496 47.8252L73.6903 44.0368H78.4851L78.4283 45.2703H74.8825L74.738 47.0716C75.0133 46.9168 75.2748 46.8049 75.5225 46.7361C75.7737 46.6673 76.049 46.6329 76.3483 46.6329C76.8473 46.6329 77.2928 46.7275 77.6851 46.9168C78.0808 47.1026 78.3939 47.3761 78.6245 47.7374C78.855 48.0987 78.9703 48.5391 78.9703 49.0587C78.9703 49.5852 78.8516 50.0394 78.6141 50.4213C78.3767 50.8032 78.0395 51.0974 77.6025 51.3039C77.169 51.5103 76.6546 51.6135 76.0593 51.6135Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_193_7723",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_193_7723",
    transform: "scale(0.00195312)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_193_7723",
    width: 512,
    height: 512,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg25UpdatedNewTableActive);
export default __webpack_public_path__ + "static/media/25-updated-new-table-active.60280ef88a56ecebb9bd96e110194f42.svg";
export { ForwardRef as ReactComponent };